import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_ReportService } from './Utilities.report.index';
import { MovuRobotics_ReportService } from './MovuRobotics.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_ReportService);
    this.MovuRobotics = this.injector.get(MovuRobotics_ReportService);
  }
    public Utilities: Utilities_ReportService;
    public MovuRobotics: MovuRobotics_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

